
// import { apiRequest } from "./axiosInstance";


// export const createAppoinment = async (body)=>{
//     try {
        
  
//     const response = await apiRequest({
//         url: "/appoinment/createAppoinment",
//         method: "POST",
//         data:body
//       });
//       return {success:true,data:response?.data?.data,message:response?.data?.message}
//         } catch (error) {
//          return {success:false,error:error?.message,message:"Error while creating!"}
//     }
// }


// export const getAppoinmentStats = async (body)=>{
//      try {
        
  
//     const response = await apiRequest({
//         url: "/appoinment/stats",
//         method: "GET",
//         params:body
//       });
//       return {success:true,data:response?.data?.data,message:response?.data?.message}
//         } catch (error) {
//          return {success:false,error:error?.message,message:"Error while fetch!"}
//     }
// }

// //today

// export const getTodaysAppoinment = async (body)=>{
//      try {
        
  
//     const response = await apiRequest({
//         url: "/appoinment/today",
//         method: "GET",
//         params:body
//       });
//       return {success:true,data:response?.data?.data,message:response?.data?.message}
//         } catch (error) {
//          return {success:false,error:error?.message,message:"Error while fetch!"}
//     }
// }


// export const updateAppoinment = async (appointmentId, updateData) => {
//     try {
//         console.log('Update appointment:', appointmentId, updateData);
        
//         const response = await apiRequest({
//             url: `/appoinment/${appointmentId}`,
//             method: "PUT",
//             data: updateData
//         });
        
//         return {
//             success: true,
//             data: response?.data?.data,
//             message: response?.data?.message
//         }
//     } catch (error) {
//         console.error('Update appointment error:', error);
//         return {
//             success: false,
//             error: error?.response?.data?.message || error?.message,
//             message: error?.response?.data?.message || "Error while updating appointment!"
//         }
//     }
// }

// // New function specifically for updating appointment status
// export const updateAppoinmentStatus = async (appointmentId, status) => {
//     try {
//         console.log('Update appointment status:', appointmentId, status);
        
//         const response = await apiRequest({
//             url: `/appoinment/${appointmentId}/status`,
//             method: "PATCH",
//             data: { status }
//         });
        
//         return {
//             success: true,
//             data: response?.data?.data,
//             message: response?.data?.message
//         }
//     } catch (error) {
//         console.error('Update appointment status error:', error);
//         return {
//             success: false,
//             error: error?.response?.data?.message || error?.message,
//             message: error?.response?.data?.message || "Error while updating status!"
//         }
//     }
// }

// Updated appointment API service to match your URL structure
import { apiRequest } from "./axiosInstance";

export const createAppoinment = async (body) => {
    try {
        const response = await apiRequest({
            url: "/appoinment/createAppoinment",
            method: "POST",
            data: body
        });
        return {
            success: true,
            data: response?.data?.data,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Create appointment error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while creating appointment!"
        }
    }
}

export const getAppoinmentStats = async (params) => {
    try {
        console.log('API call params:', params);
        
        const response = await apiRequest({
            url: "/appoinment/stats",
            method: "GET",
            params: params
        });
        
        console.log('API response:', response?.data);
        
        return {
            success: true,
            data: response?.data?.data,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Get appointment stats error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while fetching stats!"
        }
    }
}

// Updated to handle both single date and date range using /today endpoint
export const getTodaysAppoinment = async (params) => {
    try {
        console.log('Appointment fetch params:', params);
        
        const response = await apiRequest({
            url: "/appoinment/today", // Using your existing /today endpoint
            method: "GET",
            params: params
        });
        
        console.log('Appointments response:', response?.data);
        
        return {
            success: true,
            data: response?.data?.data,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Get appointments error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while fetching appointments!"
        }
    }
}

// New function for updating appointments
export const updateAppoinment = async (appointmentId, updateData) => {
    try {
        console.log('Update appointment:', appointmentId, updateData);
        
        const response = await apiRequest({
            url: `/appoinment/${appointmentId}`,
            method: "PUT",
            data: updateData
        });
        
        return {
            success: true,
            data: response?.data?.data,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Update appointment error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while updating appointment!"
        }
    }
}

// New function for updating appointment status only
export const updateAppoinmentStatus = async (appointmentId, status) => {
    try {
        console.log('Update appointment status:', appointmentId, status);
        
        const response = await apiRequest({
            url: `/appoinment/${appointmentId}/status`,
            method: "PATCH",
            data: { status }
        });
        
        return {
            success: true,
            data: response?.data?.data,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Update appointment status error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while updating status!"
        }
    }
}

// Function to delete appointment
export const deleteAppoinment = async (appointmentId) => {
    try {
        console.log('Delete appointment:', appointmentId);
        
        const response = await apiRequest({
            url: `/appoinment/${appointmentId}`,
            method: "DELETE"
        });
        
        return {
            success: true,
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Delete appointment error:', error);
        return {
            success: false,
            error: error?.response?.data?.message || error?.message,
            message: error?.response?.data?.message || "Error while deleting appointment!"
        }
    }
}